import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DocumentoResult } from 'src/app/models/common/DocumentoResult';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class SolicitudEquipoDocumentosService {
  private configUrl = [environment.apiGatewayUrl, 'solicitudes'].join('/');

  constructor(private http: HttpClient) { }

  guardar(formData: FormData, codigo: string, idSolicitud: number){ //model: ISolicitudCompletarModel
    return this.http.post(`${this.configUrl}/${idSolicitud}/equipos/documentos/${codigo}/upload`, formData, {reportProgress: true, observe: 'events'});
  }

  downloadDocumento(codigoSolicitud: string, idSolicitudEquipo: number, id: number): Observable<Blob> {
    return this.http.get(`${this.configUrl}/${codigoSolicitud}/equipos/${idSolicitudEquipo}/documentos/${id}/download`, { responseType: 'blob' });
  }

  downloadasStringDocumento(codigoSolicitud: string, idSolicitudEquipo: number, id: number): Observable<DocumentoResult> {
    return this.http.get<DocumentoResult>(`${this.configUrl}/${codigoSolicitud}/equipos/${idSolicitudEquipo}/documentos/${id}/downloadbase64`);
  }
}
